export function truncateAddress(address, numChars = 5) {
  return address.slice(0, numChars) + "..." + address.slice(-numChars);
}
